module.exports = __webpack_public_path__ + "static/media/appDeReceitas.2c441c2f.png";